/**
 * Typed access to the player's build/runtime env.
 * - API base URL is consumed by @fixit/api-client via the process.env shim in vite.config.ts;
 *   this constant exists for diagnostics/logging only.
 * - The git sha is sent to the API on completion (provenance triple: player_code_sha).
 */
export const API_URL: string = import.meta.env.VITE_API_URL ?? 'http://127.0.0.1:3313';

export const PLAYER_CODE_SHA: string = import.meta.env.VITE_GIT_COMMIT_HASH ?? 'dev';

/**
 * Origins permitted to frame the player AND receive its embed postMessages.
 * Comma-separated absolute origins via VITE_BOZP_ALLOWED_PARENTS; defaults to the
 * local web-account dev origin plus the prod web origin. The embed handshake validates
 * `parentOrigin` against this list and never posts to '*', so the player can't be
 * coaxed into messaging an arbitrary framer. Dev/staging origins are supplied per env.
 */
const DEFAULT_ALLOWED_PARENTS = 'http://localhost:3111,https://fixit.app';

export const ALLOWED_PARENTS: readonly string[] = (
  import.meta.env.VITE_BOZP_ALLOWED_PARENTS ?? DEFAULT_ALLOWED_PARENTS
)
  .split(',')
  .map((origin: string) => origin.trim())
  .filter((origin: string) => origin.length > 0);
